import styled from "@emotion/styled";
import { TableRow } from "@mui/material";

export const ClickableTableRow = styled(TableRow)(({ theme }) => ({
	cursor: "pointer",
	"&:hover": {
		backgroundColor: theme.project.colors.backgroundColors["card:hover"]
	}
}));

export const SearchParagraphStyled = styled.p(({ theme }) => ({
	margin: "0 0 20px 0",
	color: theme.project.colors.fontColors.secondary,
	letterSpacing: "1px"
}));

export const FilteredAdminTableWrapper = styled.div(({ theme }) => ({
	[theme.breakpoints.down("md")]: {
		overflowX: "scroll"
	}
}));

export const AdminSearchRequestNoResultsFoundContainer = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	justifyContent: "center",
	alignItems: "center",
	gap: 16,
	marginTop: 16,
	color: theme.project.colors.fontColors.main,
	h1: {
		...theme.project.typography.heading.h6,
		margin: 0
	},
	"div:nth-of-type(1)": {
		...theme.project.typography.body.body1,
		div: {
			margin: 0
		},
		ul: {
			margin: 0
		}
	},
	"div:nth-of-type(2)": {
		...theme.project.typography.caption
	}
}));
